import {PAGE_LOADED, PAGE_LOAD_REQUEST} from "../utils/Constant";

const page = function (state = {}, action) {
  switch (action.type) {
    case PAGE_LOAD_REQUEST:

      return {...state, items: []};
    case PAGE_LOADED:
      return {...state, ...{
          breadcrumbs: [],
          h1: 'Каталог детских площадок',
          h2: '',
          title: 'Игровые комплексы',
          content: '',
          ...action.data
        }};
    default :
      return state;
  }
}
export default page;
